exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".blockContainer-c2a8efa8{display:flex;margin:25px 0px}.details-f9b9a8ec{padding:0px 0px 0px 10px;color:#616161;font-size:13px;line-height:20px;display:flex;flex-direction:column}.details-f9b9a8ec .metrics-eb1ce38b{display:flex}a.routeName-39ad7983:hover{text-decoration:none}.selected-e4dd929b{display:flex}.selected-e4dd929b .ctaWrangler-6ed448fa{flex:1 0 100px;display:flex;align-items:center;justify-content:flex-start}.selected-e4dd929b .ctaWrangler-6ed448fa>a{max-width:150px;margin-left:20px}\n", ""]);

// Exports
exports.locals = {
	"blockContainer": "blockContainer-c2a8efa8",
	"details": "details-f9b9a8ec",
	"metrics": "metrics-eb1ce38b",
	"routeName": "routeName-39ad7983",
	"selected": "selected-e4dd929b",
	"ctaWrangler": "ctaWrangler-6ed448fa"
};